module.exports = __webpack_public_path__ + "static/media/imageNequi.3cc457d8.png";